export default "/images/2514c42eea18918ddb64213494ff201f.avif";